import React, { Component } from 'react'
import {  bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setCurrent, filterProj } from '../actions'
import Listproject from './listproject'

class Allprojects extends Component {

  componentWillMount() {
    let projFilter = this.props.match.params.filter || 'all';
    this.props.filterProj(projFilter);
  }
  displayProjects() {
    /* https://www.w3schools.com/colors/colors_shades.asp */
    var grey = ['#F8F8F8','#F5F5F5','#F0F0F0','#E8E8E8','#E0E0E0','#DCDCDC','#D8D8D8','#D3D3D3',
      '#D0D0D0','#C8C8C8','#C0C0C0','#BEBEBE','#B8B8B8','#B0B0B0','#A9A9A9'];
    return this.props.projects.map((project, index) => {
      return (
        <Listproject
          greyBg={grey[index]}
          index={index}
          history={this.props.history}
          project={project}
            />
      )
    })
  }

  render() {
    return (
      <div className="Allprojects projects">
        {this.displayProjects()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    current: state.current,
    projects: state.projects,
    styles: state.styles
  })
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setCurrent, filterProj
  }, dispatch)
}

const ConnectedAllprojects = connect(mapStateToProps, mapDispatchToProps)(Allprojects)

export default ConnectedAllprojects



// WEBPACK FOOTER //
// ./src/components/allprojects.js